import { render, staticRenderFns } from "./wxReviseshenheOther.vue?vue&type=template&id=49516c62&scoped=true"
import script from "./wxReviseshenheOther.vue?vue&type=script&lang=js"
export * from "./wxReviseshenheOther.vue?vue&type=script&lang=js"
import style0 from "./wxReviseshenheOther.vue?vue&type=style&index=0&id=49516c62&prod&scoped=true&lang=css"
import style1 from "./wxReviseshenheOther.vue?vue&type=style&index=1&id=49516c62&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49516c62",
  null
  
)

export default component.exports